// extracted by mini-css-extract-plugin
export var label = "_is-0";
export var treatmentCard = "_is-1";